import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subject-attempt-resolution-outcomes-quick-rate-widget',
  templateUrl: './subject-attempt-resolution-outcomes-quick-rate-widget.component.html',
  styleUrls: ['./subject-attempt-resolution-outcomes-quick-rate-widget.component.scss']
})
export class SubjectAttemptResolutionOutcomesQuickRateWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
